import React from 'react'
import PropTypes from 'prop-types'
import { Tabs as AntDTabs } from 'antd'
import withStyle from './Tabs.style.js'

const Tabs = ({
  className,
  tabs,
  activeKey,
  onTabClick,
  tabPanes,
  defaultActiveKey,
  renderTabBar,
}) => (
  <AntDTabs
    tabs={tabs}
    defaultActiveKey={defaultActiveKey}
    activeKey={activeKey}
    onTabClick={onTabClick}
    renderTabBar={renderTabBar}
    className={className}
  >
    {tabPanes.map(({ tab, content, key, disabled }) => (
      <AntDTabs.TabPane key={key || tab} disabled={disabled} tab={tab}>
        {content}
      </AntDTabs.TabPane>
    ))}
  </AntDTabs>
)

Tabs.propTypes = {
  tabs: PropTypes.bool,
  activeKey: PropTypes.string,
  defaultActiveKey: PropTypes.string,
  onTabClick: PropTypes.func,
  renderTabBar: PropTypes.func,
  tabPanes: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      disabled: PropTypes.string,
      tab: PropTypes.string,
      content: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
    })
  ), // array of what shape object
  className: PropTypes.string,
}
export default withStyle(Tabs)
